import { OrderLineCollectionStatus, OrderLineRefundStatus, OrderTicketAdmissionStatus, TicketTypeType } from '@vista-digital/ocapi-types/v1';
import { createFilledArray } from '../../../utils/array-utils';
import { createUUID } from '../../../utils/uuid-utils';
import { getTicketTypeById } from '../../sales-data/selectors/tickets/get-ticket-type-by-id';
export const mapTicketDetailsToOrderTicketLine = (price) => {
    const ticketType = getTicketTypeById(price.ticketTypeId);
    return ticketType.type === TicketTypeType.Package
        ? mapTicketDetailsToOrderPackageTicketLine(price, ticketType)
        : mapTicketDetailsToOrderNormalTicketLine(price);
};
const mapTicketDetailsToOrderTicketLineBase = (ticket) => {
    return Object.assign(Object.assign({}, ticket), { 
        // TODO: Update this when ticket discounts are supported. #286514
        amountSaved: {
            valueIncludingTax: 0,
            valueExcludingTax: 0,
            tax: 0
        }, id: createUUID(), bookingFee: mapTicketPriceBookingFeeToOrderBookingFeeLine(ticket.bookingFee), type: TicketTypeType.Normal, collectionStatus: OrderLineCollectionStatus.NotCollected, refundStatus: OrderLineRefundStatus.NotRefunded });
};
const mapTicketDetailsToOrderNormalTicketLine = (ticket) => {
    return Object.assign(Object.assign({}, mapTicketDetailsToOrderTicketLineBase(ticket)), { type: TicketTypeType.Normal, admissionStatus: OrderTicketAdmissionStatus.NotAdmitted });
};
const mapTicketDetailsToOrderPackageTicketLine = (ticket, ticketType) => {
    return Object.assign(Object.assign({}, mapTicketDetailsToOrderTicketLineBase(ticket)), { type: TicketTypeType.Package, tickets: mapPackageContentTicketsToOrderPackageTicketContentTickets(ticketType.tickets), items: mapPackageContentItemsToOrderPackageTicketContentItems(ticketType.items) });
};
const mapPackageContentTicketsToOrderPackageTicketContentTickets = (tickets) => {
    return tickets.reduce((acc, ticket) => {
        const mappedTickets = createFilledArray({
            ticketTypeId: ticket.ticketTypeId,
            admissionStatus: OrderTicketAdmissionStatus.NotAdmitted
        }, ticket.quantity);
        return [...acc, ...mappedTickets];
    }, []);
};
const mapPackageContentItemsToOrderPackageTicketContentItems = (items) => {
    return items.reduce((acc, item) => {
        const mappedItems = createFilledArray({ itemId: item.itemId }, item.quantity);
        return [...acc, ...mappedItems];
    }, []);
};
const mapTicketPriceBookingFeeToOrderBookingFeeLine = (bookingFee) => {
    if (!bookingFee)
        return undefined;
    return {
        amount: {
            valueIncludingTax: bookingFee.amountIncludingTax,
            valueExcludingTax: bookingFee.amountIncludingTax,
            tax: 0
        },
        id: createUUID(),
        collectionStatus: OrderLineCollectionStatus.NotCollected,
        refundStatus: OrderLineRefundStatus.NotRefunded
    };
};
export const mapOrderTicketLineToOrderTicketRequest = (ticket) => {
    return {
        id: ticket.id,
        ticketTypeId: ticket.ticketTypeId,
        rewardId: ticket.rewardId,
        voucherId: ticket.voucherId,
        ticketRedemptionCardId: ticket.ticketRedemptionCardId
    };
};
